import { API_ENDPOINTS } from "@/config/api";
import { fetchApi } from "./api";

export type BusinessAccountStatus = "none" | "active" | "past_due" | "canceled";

export interface BusinessAccount {
  id: number;
  name: string;
  email: string;
  contact_name: string | null;
  website_url: string | null;
  description: string | null;
  source_id: string | null;
  subscription_tier: number;
  subscription_status: BusinessAccountStatus | string;
  is_active: boolean;
  is_eligible: boolean;
  invited_at: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface CreateBusinessAccountRequest {
  name: string;
  email: string;
  contact_name?: string | null;
  website_url?: string | null;
  description?: string | null;
  source_id?: string | null;
  subscription_tier?: number;
  subscription_status?: BusinessAccountStatus | string;
}

export interface PatchBusinessAccountRequest {
  name?: string;
  contact_name?: string | null;
  website_url?: string | null;
  description?: string | null;
  source_id?: string | null;
  subscription_tier?: number;
  subscription_status?: BusinessAccountStatus | string;
  is_active?: boolean;
}

export async function listBusinessAccounts(): Promise<BusinessAccount[]> {
  return fetchApi<BusinessAccount[]>(API_ENDPOINTS.businessAccounts);
}

export async function createBusinessAccount(
  data: CreateBusinessAccountRequest,
): Promise<BusinessAccount> {
  return fetchApi<BusinessAccount>(API_ENDPOINTS.businessAccounts, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function patchBusinessAccount(
  id: number,
  patch: PatchBusinessAccountRequest,
): Promise<BusinessAccount> {
  return fetchApi<BusinessAccount>(API_ENDPOINTS.businessAccount(id), {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export async function resendBusinessAccountInvite(
  id: number,
): Promise<BusinessAccount> {
  return fetchApi<BusinessAccount>(
    API_ENDPOINTS.businessAccountResendInvite(id),
    { method: "POST" },
  );
}

export async function deleteBusinessAccount(id: number): Promise<void> {
  await fetchApi<void>(API_ENDPOINTS.businessAccount(id), {
    method: "DELETE",
  });
}
